//SFX
import Buzzer from "audio/sfx/Buzzer.mp3";
import ButtonPress from "audio/sfx/ButtonPress.mp3";
import CorrectAnswer from "audio/sfx/CorrectAnswer.mp3";
import IncorrectAnswer from "audio/sfx/IncorrectAnswer.mp3";
import RoundEnd from "audio/sfx/RoundEnd.mp3";
import Winners from "audio/sfx/Winners.mp3";
import Tik from "audio/sfx/Tik.mp3";
import Tok from "audio/sfx/Tok.mp3";
import TimesUpBell from "audio/sfx/TimesUpBell.mp3";
import Pass from "audio/sfx/Pass.mp3";
import SegmentReveal from "audio/sfx/SegmentReveal.mp3";

//Music
import MenuMusic from "audio/music/MenuMusic.mp3";
import RoundOneMusic from "audio/music/RoundOneMusic.mp3";
import RoundTwoMusic from "audio/music/RoundTwoMusic.mp3";
import RoundThreeMusic from "audio/music/RoundThreeMusic.mp3";
import RoundSummaryMusic from "audio/music/RoundSummaryMusicShort.mp3";
import EndGameMusic from "audio/music/EndGameMusic.mp3";

//VO
import VO_Intro from "audio/vo/Intro.mp3";
import VO_GameLengthSelect from "audio/vo/GameLengthSelect.mp3";
import VO_GameModeSelect from "audio/vo/GameModeSelect.mp3";
import VO_TeamSelect from "audio/vo/TeamSelect.mp3";
import VO_GridViewingTimesUp from "audio/vo/GridViewingTimesUp.mp3";
import VO_RoundOneIntro from "audio/vo/RoundOneIntro.mp3";
import VO_RoundTwoIntro from "audio/vo/RoundTwoIntro.mp3"
import VO_RoundThreeIntro from "audio/vo/RoundThreeIntro.mp3";
import VO_RoundOneSummary from "audio/vo/RoundOneSummary.mp3";
import VO_RoundTwoSummary from "audio/vo/RoundTwoSummary.mp3";
import VO_RoundThreeSummary from "audio/vo/RoundThreeSummary.mp3";
import VO_IncorrectVariantOne from "audio/vo/IncorrectVariantOne.mp3";
import VO_IncorrectVariantTwo from "audio/vo/IncorrectVariantTwo.mp3";
import VO_IncorrectVariantThree from "audio/vo/IncorrectVariantThree.mp3";
import VO_IncorrectVariantFive from "audio/vo/IncorrectVariantFive.mp3";
import VO_TimedOutVariantOne from "audio/vo/TimedOutVariantOne.mp3";
import VO_TimedOutVariantTwo from "audio/vo/TimedOutVariantTwo.mp3";
import VO_CorrectVariantOne from "audio/vo/CorrectVariantOne.mp3";
import VO_CorrectVariantTwo from "audio/vo/CorrectVariantTwo.mp3";
import VO_CorrectVariantThree from "audio/vo/CorrectVariantThree.mp3";
import VO_CorrectVariantFour from "audio/vo/CorrectVariantFour.mp3";
import VO_CorrectVariantFive from "audio/vo/CorrectVariantFive.mp3";
import VO_LockedOut from "audio/vo/LockedOut.mp3";
import VO_BonusBoardIntro from "audio/vo/BonusBoardIntro.mp3";
import VO_BonusBoardReturn from "audio/vo/BonusBoardReturn.mp3";
import VO_RoundTimesUpVariantOne from "audio/vo/RoundTimesUpVariantOne.mp3";
import VO_RoundTimesUpVariantTwo from "audio/vo/RoundTimesUpVariantTwo.mp3";
import VO_RoundTimesUpVariantThree from "audio/vo/RoundTimesUpVariantThree.mp3";
import VO_PhraseQuipVariantOne from "audio/vo/PhraseQuipVariantOne.mp3";
import VO_PhraseQuipVariantTwo from "audio/vo/PhraseQuipVariantTwo.mp3";
import VO_PhraseQuipVariantThree from "audio/vo/PhraseQuipVariantThree.mp3";
import VO_PhraseQuipVariantFour from "audio/vo/PhraseQuipVariantFour.mp3";
import VO_PhraseQuipVariantFive from "audio/vo/PhraseQuipVariantFive.mp3";
import VO_PhraseQuipVariantSix from "audio/vo/PhraseQuipVariantSix.mp3";
import VO_FirstPhraseIntro from "audio/vo/FirstPhraseIntro.mp3";
import VO_NextPhraseIntroVariantOne from "audio/vo/NextPhraseIntroVariantOne.mp3";
import VO_NextPhraseIntroVariantTwo from "audio/vo/NextPhraseIntroVariantTwo.mp3";
import VO_NextPhraseIntroVariantThree from "audio/vo/NextPhraseIntroVariantThree.mp3";
import VO_NextPhraseIntroVariantFour from "audio/vo/NextPhraseIntroVariantFour.mp3";
import VO_NextPhraseIntroVariantFive from "audio/vo/NextPhraseIntroVariantFive.mp3";
import VO_PreSelectTeamVariantOne from "audio/vo/PreSelectTeamVariantOne.mp3";
import VO_PreSelectTeamVariantTwo from "audio/vo/PreSelectTeamVariantTwo.mp3";
import VO_PreSelectTeamVariantThree from "audio/vo/PreSelectTeamVariantThree.mp3";
import VO_PreSelectAutoVariantOne from "audio/vo/PreSelectAutoVariantOne.mp3";
import VO_PreSelectAutoVariantTwo from "audio/vo/PreSelectAutoVariantTwo.mp3";
import VO_PreSelectLastVariantOne from "audio/vo/PreSelectLastVariantOne.mp3";
import VO_PreSelectLastVariantTwo from "audio/vo/PreSelectLastVariantTwo.mp3";
import VO_PostRevealAnswerVariantOne from "audio/vo/PostRevealAnswerVariantOne.mp3";
import VO_PostRevealAnswerVariantTwo from "audio/vo/PostRevealAnswerVariantTwo.mp3";
import VO_PostRevealAnswerVariantThree from "audio/vo/PostRevealAnswerVariantThree.mp3";
import VO_PostRevealViewingVariantOne from "audio/vo/PostRevealViewingVariantOne.mp3";
import VO_PostRevealViewingVariantTwo from "audio/vo/PostRevealViewingVariantTwo.mp3";
import VO_PostRevealAllAnswerVariantOne from "audio/vo/PostRevealAllAnswerVariantOne.mp3";
import VO_PostRevealAllAnswerVariantTwo from "audio/vo/PostRevealAllAnswerVariantTwo.mp3";
import VO_MidRoundQuipVariantOne from "audio/vo/MidRoundQuipVariantOne.mp3";
import VO_MidRoundQuipVariantTwo from "audio/vo/MidRoundQuipVariantTwo.mp3";
import VO_MidRoundQuipVariantThree from "audio/vo/MidRoundQuipVariantThree.mp3";
import VO_MidRoundQuipVariantFour from "audio/vo/MidRoundQuipVariantFour.mp3";
import VO_MidRoundQuipVariantFive from "audio/vo/MidRoundQuipVariantFive.mp3";
import VO_MidRoundQuipVariantSix from "audio/vo/MidRoundQuipVariantSix.mp3";
import VO_MidRoundQuipVariantSeven from "audio/vo/MidRoundQuipVariantSeven.mp3";
import VO_MidRoundQuipVariantEight from "audio/vo/MidRoundQuipVariantEight.mp3";
import VO_MidRoundQuipVariantNine from "audio/vo/MidRoundQuipVariantNine.mp3";
import VO_MidRoundQuipVariantTen from "audio/vo/MidRoundQuipVariantTen.mp3";
import VO_TimesNearlyUpVariantOne from "audio/vo/TimesNearlyUpVariantOne.mp3";
import VO_BuzzInQuipVariantOne from "audio/vo/BuzzInQuipVariantOne.mp3";
import VO_Winners from "audio/vo/Winners.mp3";
import VO_AllPassed from "audio/vo/AllPassed.mp3";

export const MUSIC = {
    MENU: { src: MenuMusic, volume: 0.2, loop: true },
    ROUND_ONE: { src: RoundOneMusic, volume: 0.25, loop: true },
    ROUND_TWO: { src: RoundTwoMusic, volume: 0.25, loop: true },
    ROUND_THREE: { src: RoundThreeMusic, volume: 0.25, loop: true },
    ROUND_SUMMARY: { src: RoundSummaryMusic, volume: 0.25, loop: true },
    END_GAME: { src: EndGameMusic, volume: 0.25, loop: true },
};

export const SFX = {
    BUZZER: { src: Buzzer, volume: 1 },
    BUTTON_PRESS: { src: ButtonPress, volume: 0.2 },
    CORRECT_ANSWER: { src: CorrectAnswer, volume: 0.8 },
    INCORRECT_ANSWER: { src: IncorrectAnswer, volume: 0.8 },
    ROUND_END: { src: RoundEnd, volume: 0.8 },
    WINNERS: { src: Winners, volume: 0.8 },
    TIK: { src: Tik, volume: 0.6 },
    TOK: { src: Tok, volume: 0.6 },
    TIMES_UP_BELL: { src: TimesUpBell, volume: 0.8 },
    PASS: { src: Pass, volume: 0.8 },
    SEGMENT_REVEAL: { src: SegmentReveal, volume: 0.8 },
};

export const VO = {
    INTRO: { src: VO_Intro, volume: 1 },
    GAME_LENGTH_SELECT: { src: VO_GameLengthSelect, volume: 1 },
    GAME_MODE_SELECT: { src: VO_GameModeSelect, volume: 1 },
    TEAM_SELECT: { src: VO_TeamSelect, volume: 1 },
    ROUND_ONE_INTRO: { src: VO_RoundOneIntro, volume: 1 },
    ROUND_TWO_INTRO: { src: VO_RoundTwoIntro, volume: 1 },
    ROUND_THREE_INTRO: { src: VO_RoundThreeIntro, volume: 1 },
    ROUND_ONE_SUMMARY: { src: VO_RoundOneSummary, volume: 1 },
    ROUND_TWO_SUMMARY: { src: VO_RoundTwoSummary, volume: 1 },
    ROUND_THREE_SUMMARY: { src: VO_RoundThreeSummary, volume: 1 },
    INCORRECT: [
        { src: VO_IncorrectVariantOne, volume: 1 },
        { src: VO_IncorrectVariantTwo, volume: 1 },
        { src: VO_IncorrectVariantThree, volume: 1 },
        { src: VO_IncorrectVariantFive, volume: 1 },
    ],
    TIMED_OUT: [
        { src: VO_TimedOutVariantOne, volume: 1 },
        { src: VO_TimedOutVariantTwo, volume: 1 },
    ],
    CORRECT: [
        { src: VO_CorrectVariantOne, volume: 1 },
        { src: VO_CorrectVariantTwo, volume: 1 },
        { src: VO_CorrectVariantThree, volume: 1 },
        { src: VO_CorrectVariantFour, volume: 1 },
        { src: VO_CorrectVariantFive, volume: 1 },
    ],
    ROUND_TIMES_UP: [
        { src: VO_RoundTimesUpVariantOne, volume: 1 },
        { src: VO_RoundTimesUpVariantTwo, volume: 1 },
        { src: VO_RoundTimesUpVariantThree, volume: 1 },
    ],
    PHRASE_QUIP: [
        { src: VO_PhraseQuipVariantOne, volume: 1 },
        { src: VO_PhraseQuipVariantTwo, volume: 1 },
        { src: VO_PhraseQuipVariantThree, volume: 1 },
        { src: VO_PhraseQuipVariantFour, volume: 1 },
        { src: VO_PhraseQuipVariantFive, volume: 1 },
        { src: VO_PhraseQuipVariantSix, volume: 1 },
    ],
    MID_ROUND_QUIP: [
        { src: VO_MidRoundQuipVariantOne, volume: 1 },
        { src: VO_MidRoundQuipVariantTwo, volume: 1 },
        { src: VO_MidRoundQuipVariantThree, volume: 1 },
        { src: VO_MidRoundQuipVariantFour, volume: 1 },
        { src: VO_MidRoundQuipVariantFive, volume: 1 },
        { src: VO_MidRoundQuipVariantSix, volume: 1 },
        { src: VO_MidRoundQuipVariantSeven, volume: 1 },
        { src: VO_MidRoundQuipVariantEight, volume: 1 },
        { src: VO_MidRoundQuipVariantNine, volume: 1 },
        { src: VO_MidRoundQuipVariantTen, volume: 1 },
    ],
    TIMES_NEARLY_UP: [
        { src: VO_TimesNearlyUpVariantOne, volume: 1 },
    ],
    BUZZ_IN_QUIP: [
        { src: VO_BuzzInQuipVariantOne, volume: 1 },
    ],
    LOCKED_OUT: { src: VO_LockedOut, volume: 1 },
    BONUS_BOARD_INTRO: { src: VO_BonusBoardIntro, volume: 1 },
    BONUS_BOARD_RETURN: { src: VO_BonusBoardReturn, volume: 1 },
    GRID_VIEWING_TIMES_UP: { src: VO_GridViewingTimesUp, volume: 1 },
    PRE_SELECT_TEAM: [
        { src: VO_PreSelectTeamVariantOne, volume: 1 },
        { src: VO_PreSelectTeamVariantTwo, volume: 1 },
        { src: VO_PreSelectTeamVariantThree, volume: 1 },
    ],
    PRE_SELECT_AUTO: [
        { src: VO_PreSelectAutoVariantOne, volume: 1 },
        { src: VO_PreSelectAutoVariantTwo, volume: 1 },
    ],
    PRE_SELECT_LAST: [
        { src: VO_PreSelectLastVariantOne, volume: 1 },
        { src: VO_PreSelectLastVariantTwo, volume: 1 },
    ],
    POST_REVEAL_ANSWER: [
        { src: VO_PostRevealAnswerVariantOne, volume: 1 },
        { src: VO_PostRevealAnswerVariantTwo, volume: 1 },
        { src: VO_PostRevealAnswerVariantThree, volume: 1 },
    ],
    POST_REVEAL_VIEWING: [
        { src: VO_PostRevealViewingVariantOne, volume: 1 },
        { src: VO_PostRevealViewingVariantTwo, volume: 1 },
    ],
    POST_REVEAL_ALL_ANSWER: [
        { src: VO_PostRevealAllAnswerVariantOne, volume: 1 },
        { src: VO_PostRevealAllAnswerVariantTwo, volume: 1 },
    ],
    FIRST_PHRASE_INTRO: { src: VO_FirstPhraseIntro, volume: 1 },
    NEXT_PHRASE_INTRO: [
        { src: VO_NextPhraseIntroVariantOne, volume: 1 },
        { src: VO_NextPhraseIntroVariantTwo, volume: 1 },
        { src: VO_NextPhraseIntroVariantThree, volume: 1 },
        { src: VO_NextPhraseIntroVariantFour, volume: 1 },
        { src: VO_NextPhraseIntroVariantFive, volume: 1 },
    ],
    WINNERS: { src: VO_Winners, volume: 1 },
    ALL_PASSED: { src: VO_AllPassed, volume: 1 },
};

/** Pick a random variant if array, or return the definition directly. */
export function pickVariant(voEntry) {
    if (Array.isArray(voEntry)) {
        return voEntry[Math.floor(Math.random() * voEntry.length)];
    }
    return voEntry;
}

/** Flatten VO object into an array of definitions (for priming). */
export function flattenVO(voObj) {
    const result = [];
    for (const value of Object.values(voObj)) {
        if (Array.isArray(value)) {
            result.push(...value);
        } else {
            result.push(value);
        }
    }
    return result;
}
